import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { deliveriesType, deliveryType, filterAmountType } from '../../types';

const initialState: deliveriesType = {
    deliveries: [],
    is_adding_delivery: false,
    is_loading_deliveries: false,
    is_updating_delivery: false,
    filteredAmount: {
        deliveredTotal: 0,
        awaitApprovalTotal: 0,
        approvedTotal: 0,
        cancelledTotal: 0,
        total: 0
    }
};

const deliverySlice = createSlice({
    name: 'delivery',
    initialState,
    reducers: {
        getDeliveriesSuccess: (state, actions: PayloadAction<Array<deliveryType>>) => {
            return {
                ...state,
                deliveries: actions.payload
            };
        },
        onAddingDelivery: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_delivery: actions.payload
            };
        },
        onLoadingDeliveries: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_deliveries: actions.payload
            };
        },
        onUpdatingDelivery: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_delivery: actions.payload,
            };
        },
        onFilterDeliveriesTotal: (state, actions: PayloadAction<filterAmountType>) => {
            return {
                ...state,
                filteredAmount: actions.payload
            };
        }
    }
});

export const { getDeliveriesSuccess, onAddingDelivery, onLoadingDeliveries, onUpdatingDelivery, onFilterDeliveriesTotal } = deliverySlice.actions;

export default deliverySlice.reducer;